import { ActionButtonTheme } from "./types";

export const defaultTheme: ActionButtonTheme = {
  base: "inline-flex items-center justify-center w-full h-[44px] min-h-[44px] px-6 py-[11px] text-[15px] font-medium leading-[22px] tracking-[1.5px] text-center bg-transparent rounded-none cursor-pointer transition-all duration-200",
  hover: "hover:opacity-90",
  active: "active:opacity-80 active:scale-[0.98]",
  disabled: "disabled:cursor-not-allowed",
  focus: "focus:outline-2 focus:outline-current focus:outline-offset-2",
  loading: "cursor-wait",
  pill: "rounded-full",
};
